import { render, staticRenderFns } from "./ShieldContact.vue?vue&type=template&id=bead150c&scoped=true&"
import script from "./ShieldContact.vue?vue&type=script&lang=js&"
export * from "./ShieldContact.vue?vue&type=script&lang=js&"
import style0 from "./ShieldContact.vue?vue&type=style&index=0&id=bead150c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bead150c",
  null
  
)

export default component.exports